import React, { useState } from 'react';

const AlertContext = React.createContext();

export const AlertProvider = ({children}) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = (message, type = "info") => {
      const id = Math.floor(Math.random()*1000000);
      const newAlert = {id, message, type};
      setAlerts((prev) => [...prev, newAlert]);

      setTimeout(() => {
          hideAlert(id);
      }, 5000); // Hide the alert after 5 seconds
  }

  const hideAlert = (id) => {
      setAlerts((prev) => prev.filter((alert) => alert.id !== id));
  }

  return (
      <AlertContext.Provider value={{alerts, showAlert, hideAlert}}>
          {children}
      </AlertContext.Provider>
  );
}

export const useAlert = () => {
  return React.useContext(AlertContext);
}

export const Alert = () => {
  const { alerts, hideAlert } = useAlert();
  
  if(alerts.length === 0)
      return null;

  return (
    <div key={alert.key} className="fixed z-50 inset-x-0 top-0 px-4 py-6 space-y-4 flex flex-col items-end">
      {alerts.map(({id, message, type}) => (
      <div 
          key={id}
          className={`max-w-sm w-full shadow-lg rounded px-4 py-3 rounded relative  border-r-4 ${
              type === 'info' ? 'bg-primary border-violet-500 text-white' :
              type === 'error' ? 'bg-rose-400 border-red-600 text-red-800' :
              'bg-emerald-300 border-green-600 text-green-800'}
          `}
      >
        <div className="p-2">
          <div className="flex items-center">
            <div className="ml-3 flex-shrink-0 flex">
              <button className="inline-flex text-white cursor-pointer" onClick={() => hideAlert(id)}>
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
                </svg>
              </button>
            </div>
            <div><p className="leading-5 font-semibold">{message}</p></div>
          </div>
        </div>
      </div>
      ))}
    </div>
  );
}